"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outliner = exports.makeNote = void 0;
var React = require("react");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var note_editor_1 = require("./lib/note-editor");
var note_tree_1 = require("./lib/note-tree");
//
// The ID of the next note to create.
// This is just to make sure that new notes have an locally unique id.
//
var nextNoteId = 0;
function makeNote(text, hasFocus, children) {
    nextNoteId += 1;
    return {
        id: nextNoteId.toString(),
        text: text,
        hasFocus: hasFocus,
        children: children || [],
    };
}
exports.makeNote = makeNote;
var INDENT_STEP = 35;
var Outliner = /** @class */ (function (_super) {
    __extends(Outliner, _super);
    function Outliner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            noteTree: new note_tree_1.NoteTree({
                id: "root",
                text: "",
                children: _this.props.notes || [],
            }),
        };
        _this.onDragEnd = _this.onDragEnd.bind(_this);
        return _this;
    }
    //
    // Event raised when drag and drop has completed.
    //
    Outliner.prototype.onDragEnd = function (result, provided) {
        if (!result.destination) {
            return; // Dropped outside the list.
        }
        // Find the location of the dragged note.
        var sourceNotes;
        var sourceIndex;
        var sourceParentNote = this.state.noteTree.getNote(result.source.droppableId);
        if (sourceParentNote) {
            sourceNotes = sourceParentNote.children;
            sourceIndex = result.source.index;
        }
        else {
            throw new Error("Failed to find source parent note " + result.source.droppableId);
        }
        // Find the location where the note was dropped.
        var destNotes;
        var destIndex;
        var destParentNote = this.state.noteTree.getNote(result.destination.droppableId);
        if (destParentNote) {
            destNotes = destParentNote.children;
            destIndex = result.destination.index;
        }
        else {
            throw new Error("Failed to find dest parent note " + result.destination.droppableId);
        }
        // Remove dragged note (and children).
        var removed = sourceNotes.splice(sourceIndex, 1)[0];
        // Put the note back at the position where it was dropped.
        destNotes.splice(destIndex, 0, removed);
        this.forceUpdate();
    };
    //
    // Creates a new note.
    //
    Outliner.prototype.createNote = function (parentNote, noteIndex) {
        var newNote = makeNote("", true);
        this.state.noteTree.addNote(parentNote, noteIndex, newNote);
        this.forceUpdate();
        if (this.props.onNotesUpdated) {
            this.props.onNotesUpdated(this.state.noteTree.getRootNote().children);
        }
    };
    //
    // Deletes a note.
    //
    Outliner.prototype.deleteNote = function (parentNote, noteIndex) {
        var prevNote = this.state.noteTree.getPrevNote(parentNote, noteIndex);
        // Remove the note the user wants to delete.
        this.state.noteTree.removeNote(parentNote, noteIndex);
        if (prevNote) {
            prevNote.hasFocus = true; // Focus the previous note.
        }
        this.forceUpdate();
        if (this.props.onNotesUpdated) {
            this.props.onNotesUpdated(this.state.noteTree.getRootNote().children);
        }
    };
    //
    // Indents a note one level.
    //
    Outliner.prototype.indentNote = function (parentNote, noteIndex) {
        if (noteIndex <= 0) {
            return; // Can't indent the first note!
        }
        var newParentNote = parentNote.children[noteIndex - 1];
        this.state.noteTree.moveNote(parentNote, noteIndex, newParentNote, 0);
        this.forceUpdate();
        if (this.props.onNotesUpdated) {
            this.props.onNotesUpdated(this.state.noteTree.getRootNote().children);
        }
    };
    //
    // Unindents a note one level.
    //
    Outliner.prototype.unindentNote = function (parentNote, childIndex, grandParent) {
        if (grandParent) {
            this.state.noteTree.moveNote(parentNote, childIndex, grandParent, 0);
            this.forceUpdate();
            if (this.props.onNotesUpdated) {
                this.props.onNotesUpdated(this.state.noteTree.getRootNote().children);
            }
        }
    };
    //
    // Event raised to focus the next note.
    //
    Outliner.prototype.onFocusNext = function (parentNote, noteIndex, grandParent, parentIndex) {
        var nextNote = this.state.noteTree.getNextNote(parentNote, noteIndex, grandParent, parentIndex);
        if (nextNote) {
            nextNote.hasFocus = true;
            this.forceUpdate();
        }
    };
    //
    // Event raised to focus the prev note.
    //
    Outliner.prototype.onFocusPrev = function (parentNote, noteIndex) {
        var prevNote = this.state.noteTree.getPrevNote(parentNote, noteIndex);
        if (prevNote) {
            prevNote.hasFocus = true;
            this.forceUpdate();
        }
    };
    //
    // Renders children of a note.
    //
    Outliner.prototype.renderChildren = function (parentNote, indentLevel, grandParent, parentIndex) {
        var _this = this;
        return (React.createElement(react_beautiful_dnd_1.Droppable, { droppableId: parentNote.id }, function (provided, snapshot) { return (React.createElement("div", __assign({}, provided.droppableProps, { ref: provided.innerRef }),
            parentNote.children.map(function (child, childIndex) { return (_this.renderNote(child, childIndex, indentLevel, parentNote, grandParent, parentIndex)); }),
            provided.placeholder)); }));
    };
    //
    // Renders a note.
    //
    Outliner.prototype.renderNote = function (note, noteIndex, indentLevel, parent, grandParent, parentIndex) {
        // For debugging.
        // const colors = [ "red", "blue", "green", "yellow" ];
        var _this = this;
        return (React.createElement("div", { key: note.id, style: {
            // backgroundColor: colors[indentLevel], // For debugging.
            } },
            React.createElement(react_beautiful_dnd_1.Draggable, { key: note.id, draggableId: note.id, index: noteIndex }, function (provided, snapshot) { return (React.createElement("div", __assign({ key: note.id }, provided.draggableProps, { style: __assign({ display: "flex", flexDirection: "column" }, provided.draggableProps.style) }),
                React.createElement("div", { ref: provided.innerRef, style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: indentLevel * INDENT_STEP + "px",
                    } },
                    React.createElement("div", __assign({}, provided.dragHandleProps),
                        React.createElement("svg", { width: "20", height: "20" },
                            React.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "#5c6062" }))),
                    React.createElement("div", { style: {
                            marginLeft: "15px",
                            marginRight: "5px",
                            flexGrow: 1,
                            outline: "none",
                            cursor: "text",
                        } },
                        React.createElement(note_editor_1.NoteEditor, { text: note.text, hasFocus: note.hasFocus, onCreateNote: function () { return _this.createNote(parent, noteIndex); }, onDeleteNote: function () { return _this.deleteNote(parent, noteIndex); }, onIndentNote: function () { return _this.indentNote(parent, noteIndex); }, onUnindentNote: function () { return _this.unindentNote(parent, noteIndex, grandParent); }, onFocused: function () {
                                // After we have requested a note to focused, clear the field.
                                note.hasFocus = false;
                            }, onFocusNext: function () { return _this.onFocusNext(parent, noteIndex, grandParent, parentIndex); }, onFocusPrev: function () { return _this.onFocusPrev(parent, noteIndex); }, onTextChange: function (text) {
                                note.text = text;
                                if (_this.props.onNotesUpdated) {
                                    _this.props.onNotesUpdated(_this.state.noteTree.getRootNote().children);
                                }
                            } }))),
                note.children.length > 0
                    && _this.renderChildren(note, indentLevel + 1, parent, noteIndex))); })));
    };
    Outliner.prototype.render = function () {
        return (React.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: this.onDragEnd }, this.renderChildren(this.state.noteTree.getRootNote(), 0, undefined, undefined)));
    };
    return Outliner;
}(React.Component));
exports.Outliner = Outliner;
//# sourceMappingURL=index.js.map